import { useEffect } from 'react';
// import { setBasicDefaultStyles } from './utils';
import { shallowEqual, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { modelMicrositeService } from '~/components/organisms/previewBar/model-data';
import { QR_CODE_BUILDER_CREATED_ID_PARAM_NAME } from '~/constants/qr-code';
import { useAppDispatch } from '~/hooks/useRedux';
import { vCardPlusSlice } from '~/store/reducers/previewScreens/vcard-plus';
import { getVCardPlusReducer } from '~/store/reducers/previewScreens/vcard-plus/selectors';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';

import { VCARD_PLUS_TEMPLATE_0 } from './components/VCARD_PLUS_TEMPLATE_0';
import { VCARD_PLUS_TEMPLATE_1 } from './components/VCARD_PLUS_TEMPLATE_1';
import { VCARD_PLUS_TEMPLATE_2 } from './components/VCARD_PLUS_TEMPLATE_2';
import VCARD_PLUS_TEMPLATE_3 from './components/VCARD_PLUS_TEMPLATE_3';
import { VCARD_PLUS_TEMPLATE_4 } from './components/VCARD_PLUS_TEMPLATE_4';
import { VCARD_PLUS_TEMPLATE_5 } from './components/VCARD_PLUS_TEMPLATE_5';

const { actions } = vCardPlusSlice;

export function VCardPlusPreviewScreen() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const qrCodeState = useSelector(getQrCodeReducerData);
  const vcardPlusState = useSelector(getVCardPlusReducer, shallowEqual);

  const createdId = searchParams.get(QR_CODE_BUILDER_CREATED_ID_PARAM_NAME) || null;
  const selectedTemplate = vcardPlusState.selectedTemplate;

  // useEffect(() => {
  //   setBasicDefaultStyles(selectedTemplate, dispatch, actions);
  // }, [selectedTemplate]);

  useEffect(
    () => {
      // if (!vcardPlusState.micrositeData) {
      if (!createdId) {
        modelMicrositeService.vcardPlus(vcardPlusState, qrCodeState, { dispatch, actions }, true);
      }
      // }

      // if (vcardPlusState.micrositeData) {
      //   modelMicrositeService.vcardPlus(
      //     vcardPlusState,
      //     qrCodeState,
      //     { dispatch, actions },
      //     false,
      //     vcardPlusState.micrositeData,
      //   );
      // }
    },
    [
      // selectedTemplate
    ],
  );

  switch (selectedTemplate) {
    case 0:
      return <VCARD_PLUS_TEMPLATE_0 />;
    case 1:
      return <VCARD_PLUS_TEMPLATE_1 />;
    case 2:
      return <VCARD_PLUS_TEMPLATE_2 />;
    case 3:
      return <VCARD_PLUS_TEMPLATE_3 />;
    case 4:
      return <VCARD_PLUS_TEMPLATE_4 />;
    case 5:
      return <VCARD_PLUS_TEMPLATE_5 />;
    default:
      return null;
  }
}
